<div class="card-container" #container>
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('alertas') }} </h3>
        <span></span>
    </div>

    <div class="card-component">

        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="50"
            [pageable]="true" [sortable]="true" [groupable]="true" [reorderable]="true"
            [resizable]="true" [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">
            <ng-template kendoGridToolbarTemplate>

                <!-- Barra de Pesquisa -->
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox
                    style="width: 230px;" (valueChange)="onFilter($event)">
                </kendo-textbox>

                <!-- De -->
                <form class="k-form k-form-horizontal"
                    style="max-width: 200px;width: 200px; display: flex; justify-content: space-between;"
                    [formGroup]="formGroup">
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="dataDe" [text]="customMsgService.translate('de')">
                        </kendo-label>
                        <kendo-datepicker formControlName="dataDe" #dataDe></kendo-datepicker>
                    </kendo-formfield>
                </form>

                <!-- Até -->
                <form class="k-form k-form-horizontal"
                    style="max-width: 350px;width: 350px; display: flex; justify-content: space-between;"
                    [formGroup]="formGroup">
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="dataAte" [text]="customMsgService.translate('ate')">
                        </kendo-label>
                        <kendo-datepicker formControlName="dataAte" #dataAte></kendo-datepicker>
                    </kendo-formfield>
                    <button kendoButton (click)="pesquisar()" themeColor="primary">
                        {{customMsgService.translate('filtrarEntreDatas')}} </button>
                </form>

                <kendo-grid-spacer></kendo-grid-spacer>

                <!-- Botão Exportar Excel -->
                <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
                    icon="file-excel" themeColor="warning">
                </button>

                <!-- Botão Exportar PDF -->
                <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning"> </button>
            </ng-template>

            <!-- Coluna de Data e Hora -->
            <kendo-grid-column field="data" [title]="customMsgService.translate('movDataHora')" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.data | date:"dd-MM-yyyy HH:mm:ss" }} </div>
                </ng-template>
            </kendo-grid-column>

            <!-- Coluna de Tipo de Alerta -->
            <kendo-grid-column field="nomeTipoAlerta" [title]="customMsgService.translate('tipo')" [width]="80">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.nomeTipoAlerta }} </div>
                </ng-template>
            </kendo-grid-column>

            <!-- Coluna de Utilizador -->
            <kendo-grid-column field="nomeUtilizador" [title]="customMsgService.translate('user')" [width]="70">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span kendoTooltip title="{{customMsgService.translate('name')}}: {{dataItem.nomeUtilizador}} 
{{customMsgService.translate('employeeCode')}}: {{dataItem.codigoFuncionario}}
{{customMsgService.translate('cardID')}}: {{dataItem.idCartao}}">
                        <div class="customer-name"> {{ dataItem.codigoFuncionario }} </div>
                    </span>
                </ng-template>
            </kendo-grid-column>

            <!-- Coluna de Armário -->
            <kendo-grid-column field="nomeArmario" [title]="customMsgService.translate('armario')" [width]="90">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span kendoTooltip title="{{customMsgService.translate('name')}}: {{dataItem.nomeArmario}}
{{customMsgService.translate('numeroDeSerie')}}: {{dataItem.numeroDeSerieArmario}}">
                        <div class="customer-name"> {{ dataItem.nomeArmario }} </div>
                    </span>
                </ng-template>
            </kendo-grid-column>

            <!-- Coluna de Compartimento -->
            <kendo-grid-column field="nomeCompartimento" [title]="customMsgService.translate('cacifo')" [width]="50">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.nomeCompartimento }} </div>
                </ng-template>
            </kendo-grid-column>


            <!-- Coluna de Estado -->
            <kendo-grid-column field="nomeEstado" [title]="customMsgService.translate('state')" [width]="65">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.nomeEstado }} </div>
                </ng-template>
            </kendo-grid-column>

            <!-- Coluna de Notas -->
            <!--             <kendo-grid-column field="notas" [title]="customMsgService.translate('notas')" [width]="120">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.notas }} </div>
                </ng-template>
            </kendo-grid-column> -->

            <!-- Coluna de Data e Hora de Atualização -->
            <kendo-grid-column field="data" [title]="customMsgService.translate('dataHoraAtualizacao')" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.dataAtualizacao | date:"dd-MM-yyyy HH:mm:ss" }} </div>
                </ng-template>
            </kendo-grid-column>

            <!-- Botão Editar -->
            <kendo-grid-column title="" [width]="50" [hidden]="!canEdit()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="pencil" [title]="customMsgService.translate('btnEditar')"
                        (click)="openEdit(dataItem)" [primary]="true"></button>
                </ng-template>
            </kendo-grid-column>

            <!-- PDF -->
            <kendo-grid-pdf fileName="{{customMsgService.translate('alertas')}}.pdf" [repeatHeaders]="true"
                [allPages]="true" paperSize="A4" [landscape]="true" [scale]="0.6">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">
                            <div style="float: left">
                                {{ customMsgService.translate('alertas') }}
                            </div>
                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{
                            customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>

                <kendo-grid-column field="data" filter="date" [title]="customMsgService.translate('movDataHora')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeTipoAlerta" [title]="customMsgService.translate('tipo')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeArmario" [title]="customMsgService.translate('armario')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeCompartimento" [title]="customMsgService.translate('cacifo')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeEstado" [title]="customMsgService.translate('state')">
                </kendo-grid-column>

                <kendo-grid-column field="notas" [title]="customMsgService.translate('notas')">
                </kendo-grid-column>

                <kendo-grid-column field="dataAtualizacao" [title]="customMsgService.translate('dataHoraAtualizacao')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeUtilizador" [title]="customMsgService.translate('user')">
                </kendo-grid-column>

            </kendo-grid-pdf>

            <!-- Excel -->
            <kendo-grid-excel [fetchData]="allData" fileName="{{customMsgService.translate('alertas')}}.xlsx">
            </kendo-grid-excel>

        </kendo-grid>
    </div>
</div>
<div kendoDialogContainer></div>